/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Actions_EditInputs */

const es_feedback_actions_edit = /** @type {(inputs: Feedback_Actions_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar feedback`)
};

const en_feedback_actions_edit = /** @type {(inputs: Feedback_Actions_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit feedback`)
};

/**
* | output |
* | --- |
* | "Edit feedback" |
*
* @param {Feedback_Actions_EditInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_actions_edit = /** @type {((inputs?: Feedback_Actions_EditInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Actions_EditInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_actions_edit(inputs)
	return en_feedback_actions_edit(inputs)
});
export { feedback_actions_edit as "feedback.actions.edit" }